module.exports = __webpack_public_path__ + "static/media/human.88084b15.png";